import { render, staticRenderFns } from "./RelogioDePonto.vue?vue&type=template&id=1440fd7c&"
import script from "./RelogioDePonto.vue?vue&type=script&lang=js&"
export * from "./RelogioDePonto.vue?vue&type=script&lang=js&"
import style0 from "./RelogioDePonto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports